/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define([
  "backbone",
  "underscore",
  "service/stub",
  "service/factory",
  "client/localized_model",
  "service/cross_domain_ajax_channel"
], function (
  Backbone,
  _,
  Stub,
  ServiceFactory,
  LocalizedModel,
  CrossDomainAjaxChannel
) {

  var Chat = {};

  Chat.Model = LocalizedModel.extend({});

  Chat.DataCollection = Backbone.Collection.extend({
    model: Chat.Model,
    fetch: function (url, options, channelOptions, callback) {
      var that = this;
      var responseObserver = createResponseObserver();
      var optionsClone = _.clone(options || {});

      if (optionsClone.parse === undefined) {
        optionsClone.parse = true;
      }

      responseObserver.on("response", function (response, url) {
        response.id = url.id;
        response.channelOptions = channelOptions;
        that.response = response;
        that.add(response, optionsClone);
        that.remove(response);
        responseObserver.off();
      });

      responseObserver.on("error", function (error) {
        console.error(error);
        callback(error)
        responseObserver.off();
      });

      var stub = new DataServiceStub();
      var channel = new CrossDomainAjaxChannel({ url: url }, channelOptions);
      stub.cast(channel, null, responseObserver);
    }
  });

  function createResponseObserver() {
    var responseObserver = {};
    return _.extend(responseObserver, Backbone.Events);
  }

  var DataServiceStub = Chat.DataServiceStub = Stub.extend({
    path: "/api/chat/v1beta/data",
    options: { method: "GET" },
  });

  var ChatServiceFactory = Chat.ServiceFactory = function () { }

  _.extend(ChatServiceFactory.prototype, ServiceFactory.prototype, {
    cast: function (channel) {
      new DataServiceStub().cast(channel);
    },

    getChatFramePath: function () {
      return new DataServiceStub().path;
    }

  });

  return Chat;
});
